import React, { useEffect, useState } from"react";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import API_BASE_URL from"../Config/config";

const TSGMyNotes = () => {
 const [notes, setNotes] = useState([]);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState(null);
 const navigate = useNavigate();

 // 🧠 Get userId from localStorage
 const storedUser = localStorage.getItem("user");
 let userId = null;

 try {
 const parsedUser = storedUser ? JSON.parse(storedUser) : null;
 userId = parsedUser?.userId || parsedUser?.id || parsedUser?.user_id;
 } catch (err) {
 console.error("❌ Failed to parse user:", err);
 }

 // 🔁 Fetch notes
 useEffect(() => {
 const fetchNotes = async () => {
 if (!userId) {
 setError("User not logged in.");
 setLoading(false);
 return;
 }

 try {
 const res = await fetch(`${API_BASE_URL}/notes/${userId}`);
 const data = await res.json();
 console.log("✅ Fetched notes:", data);

 if (res.ok) {
 setNotes(data);
 } else {
 setError(data.error ||"Failed to fetch notes.");
 }
 } catch (err) {
 console.error("❌ Fetch error:", err);
 setError("Something went wrong while fetching notes.");
 } finally {
 setLoading(false);
 }
 };

 fetchNotes();
 }, [userId]);

 return (
 <div className="min-h-screen bg-bgMain text-body px-8 py-16 font-sans relative overflow-hidden">
 {/* Background decoration */}
 <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
 
 <div className="max-w-5xl mx-auto relative z-10">
        <div className="flex items-center gap-4 mb-12">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors group"
            title="Go Back"
          >
            <ChevronLeftIcon className="w-6 h-6 text-primary group-hover:-translate-x-1 transition-transform" />
          </button>
          <h1 className="text-4xl font-extrabold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent uppercase tracking-tighter">
            📝 TSG My Notes
          </h1>
        </div>

 {loading && (
 <div className="flex items-center gap-3 animate-pulse text-primary">
 <div className="w-5 h-5 border-2 border-primary/30 border-t-secondary rounded-full animate-spin"></div>
 Loading your notes...
 </div>
 )}
 
 {error && (
 <div className="p-6 bg-red-500/10 border border-red-500/30 rounded-2xl text-red-400 font-bold">
 {error}
 </div>
 )}
 
 {!loading && !error && notes.length === 0 && (
 <div className="text-center py-20 bg-[#F9F7FF] rounded-3xl border-2 border-[#5B21B6] shadow-xl">
 <p className="text-muted text-xl font-medium">No notes found in your collection.</p>
 </div>
 )}

 <div className="space-y-6">
 {notes.map((note) => (
 <div
 key={note.id || note.note_id}
 className="flex flex-col md:flex-row bg-[#F9F7FF] border-2 border-[#5B21B6] rounded-3xl p-8 
 shadow-2xl hover:border-[#5B21B6] transition-all duration-300 hover:scale-[1.01] group"
 >
 {/* 📜 Note Content */}
 <div className="flex-1 md:pr-8">
 <p className="text-lg text-body leading-relaxed transition-colors">
 {note.content}
 </p>
 </div>

 {/* 🚧 Vertical Divider */}
 <div className="hidden md:block w-px bg-white/10 mx-2 self-stretch" />

 {/* 📅 Date Info */}
 <div className="mt-6 md:mt-0 md:min-w-[180px] text-left md:text-right flex flex-col justify-center">
 <span className="text-xs font-bold text-muted uppercase tracking-widest mb-1">Created At</span>
 <h3 className="text-sm font-bold text-primary">
 {note.created_at ? new Date(note.created_at).toLocaleString() :"Recently"}
 </h3>
 </div>
 </div>
 ))}
 </div>
 </div>
 </div>
 );
};

export default TSGMyNotes;



